<template>
  <div id="DetailDialog_main">
    <el-dialog
      title="詳細資訊"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <el-form
        label-position="left"
        label-width="100px"
        :model="data"
      >
        <el-form-item label="押件">
          <span v-if="data.idCard === ''">無</span>
          <span v-else>{{ data.idCard }}</span>
        </el-form-item>
        <el-form-item label="車號">
          <span v-if="data.LicensePlateNumber === ''">無</span>
          <span v-else>{{ data.LicensePlateNumber }}</span>
        </el-form-item>
        <el-form-item label="備註">
          <span v-if="data.Remark === ''">無</span>
          <span v-else>{{ data.Remark }}</span>
        </el-form-item>
        <el-form-item label="影像">
          <span v-if="data.WebcamImageUrl === null || data.WebcamImageUrl === ''">（無影像）</span>
          <div
            v-else
            class="img"
            :style="`background-image: url(${data.WebcamImageUrl})`"
          />
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dialogVisible: false,
      data: {}
    }
  },
  methods: {
    openDetailDialog (data) {
      this.dialogVisible = true
      this.data = data
    }
  }
}
</script>
<style lang="sass" scoped>
#DetailDialog_main
  ::v-deep .el-dialog
    +basicDialog
    min-width: 540px
    .el-form
      text-align: left
      .el-form-item__label
        margin-right: 0
        font-weight: bold
      .el-form-item
        margin-bottom: 15px
      .img
        height: 133px
        width: 133px
        border: 1px #707070 solid
        border-radius: 8px
        background-position: center
        background-size: cover
</style>
